<template>
  <div id="index">
    <myMenu @zoomChange="initWow"></myMenu>
    <div class="pao pao_trends pao_trends2"></div>
    <img class="mainPic wow rotateInDownRightLittle" data-wow-offset="-100000" src="@/assets/index1.png">
    <div class="pao pao_trends"></div>
    <img class="mainPic2" src="@/assets/index1_1.png">
    <img class="pao pao1 wow rotateInDownLeft" data-wow-offset="-100000" src="@/assets/index2.png">
    <img class="pao pao2 wow zoomIn" data-wow-offset="-100000" src="@/assets/index3.png">
    <img class="pao pao3 wow " data-wow-offset="-100000" src="@/assets/index5.png">
    <div class="aboutpack">
      <div class="parkname_en slideInUp_p">
        <div class="wow slideInUp" data-wow-offset="-100000">BOONIE BEARS BAY</div>
      </div>
      <div class="parkname_cn slideInUp_p">
        <div class="wow slideInUp" data-wow-delay=".3s" data-wow-offset="-100000">熊出没欢乐港湾</div>
        <div class="line wow slideInLeft" data-wow-delay=".6s" data-wow-offset="-100000"></div>
      </div>
      <div class="detail wow fadeIn" data-wow-delay=".3s" data-wow-offset="-100000">宁波熊出没欢乐港湾作为宁波方特旅游度假区的配套组成部分，包含开放式主题街区、熊出没水上乐园、熊出没港湾酒店三大板块，为广大游客提供了“吃住游购娱”的全方位文旅体验。</div>
      <div class="more1" @click="$toPage('/aboutPark')">
        MORE
        <span></span>
      </div>
    </div>
    <div class="exploring">
      <div class="drops">
        <div class="drop wow" :data-wow-delay="dropFilter(k)" data-wow-offset="-100000" v-for="(v, k) in 64" :key="k"></div>
      </div>
      <div class="pao pao_green video_pao wow" data-wow-offset="-100000"></div>
      <div class="linear_word">EXPLORING JOY</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">探索欢乐</div>
      </div>
      <div class="exploring_item exploring_item1 wow bounceInLeft">
        <div class="bg">
          <div class="title">开放式主题街区</div>
          <div class="detail">开放式主题街区以《熊出没》IP为创意打造了十余个熊出没主题项目。</div>
        </div>
        <div class="cover">
          <img src="@/assets/index8.png">
        </div>
        <div class="btn" @click="$toPage('/adventurePark')">
          进入乐园
          <img src="@/assets/arrow2.png">
        </div>
      </div>
      <div class="exploring_item exploring_item2 wow bounceInRight">
        <div class="bg">
          <div class="title">熊出没水上乐园</div>
          <div class="detail">以熊出没大电影《熊出没·原始时代》为创意背景独家打造的大型水上乐园。</div>
        </div>
        <div class="cover">
          <img src="@/assets/index10.png">
        </div>
        <div class="btn" @click="$toPage('/waterPark')">
          进入乐园
          <img src="@/assets/arrow3.png">
        </div>
      </div>
      <div class="video_box wow slideInRightLittle">
        <img src="@/assets/index11.png" class="xiong xiong1">
        <div class="video">
          <video preload="auto" autoplay="autoplay" muted loop="loop" controls="controls" src="@/assets/video.mp4" disablepictureinpicture poster="@/assets/index14.png" id="video"></video>
          <div class="video_gray"></div>
          <div class="video_btn video_btn1"></div>
          <div class="video_btn video_btn2">
            <img src="@/assets/arrow4.png">
          </div>
        </div>
        <img src="@/assets/index12.png" class="xiong xiong2">
      </div>
    </div>
    <div class="entertainment">
      <div class="pao pao_green entertainment_pao wow" data-wow-offset="-100000"></div>
      <div class="linear_word">ENTERTAINMENT</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">休闲娱乐</div>
      </div>
      <div class="tag wow flipInX" data-wow-delay="0.6s"></div>
      <div class="tip wow" data-wow-delay="0.6s">涵盖影院剧场、体验项目、美食餐饮等多元业态，定期开展缤纷主题活动，打造潮玩嗨购新体验。</div>
      <div @click="toPageHref('/entertainment',v.index)" class="entertainment_item wow" :data-wow-delay="v.delay * 0.3 + 's'" :data-wow-offset="k == 0 ? '' : '-100000'" :class="'entertainment_item' + (k + 1)" v-for="(v, k) in entertainmentList" :key="k">
        <div class="pic_box">
          <img class="pic" :src="v.pic">
        </div>
        <div class="main_p">
          <div class="main" :style="{
						'background-image': 'url(' + v.picBg + ')',
					}">
            <div class="name">{{ v.name }}</div>
            <div class="detail">{{ v.detail }}</div>
            <div class="btn">
              MORE
              <span></span>
            </div>
          </div>
          <div class="pic2_box">
            <img class="pic2" :src="v.picBg2">
          </div>
        </div>
      </div>
    </div>
    <div class="activities">
      <div class="linear_word">RECOMMEND</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">精彩推荐</div>
      </div>
      <div class="no_list" v-if="activitieList.length==0">
        <img src="@/assets/no-data.png" alt="" srcset="">
        <span>暂无数据</span>
      </div>
      <div class="activities_list" v-else>
        <div class="wrapper" ref="wrapper" :style="{
					left: activitieLeft + 'px'
				}">
          <div class="activities_item wow slideInRightLittle" :data-wow-delay="k * 0.3 + 's'" :class="{
						['activities_item' + ((k % 4) + 1)]: true,
						'activities_item_active': v.active,
						'activities_item_empty': !v.news_id,
					}" v-for="(v, k) in activitieList" :key="k" ref="activitiesItem">
            <div class="main">
              <div class="m_name">{{ v.news_title }}</div>
              <div class="btn" :data-id='k'>
                MORE
                <img src="@/assets/arrow2.png">
              </div>
            </div>
            <div class="cover">
              <div class="pic_after" :style="{'background-image': v.news_bigpic? `url(${v.news_bigpic})`: 'url('+require('@/assets/active_bg.png')+')'}"></div>
              <div class="cover_before"></div>
              <div class="pic_before" style="background-image: 'url(@/assets/activities1.png')"></div>
              <div class="name">
                <div class="icon">
                </div>
                <!-- <span class="order">0{{ k + 1 }}</span> -->
                <span>{{ v.news_title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="food">
      <div class="linear_word">GOURMET FOOD</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">特选美食</div>
      </div>
      <div class="food_list">
        <div class="left wow fadeInLeftBig">
          <div class="food_item food_item1" @click="toPageHref('/catering',2)">
            <div class="pic" :style="{'background-image': 'url(' + foodList[0].pic + ')' }"></div>
            <div class="bottom">
              <div class="name">{{ foodList[0].name }}</div>
              <div class="more"><span>MORE</span><img src="@/assets/arrow8.png"></div>
            </div>
          </div>
        </div>
        <div class="right wow fadeInRightBig">
          <div class="food_item food_item2" @click="toPageHref('/catering',1)">
            <div class="pic" :style="{'background-image': 'url(' + foodList[1].pic + ')' }"></div>
            <div class="bottom">
              <div class="name">{{ foodList[1].name }}</div>
              <div class="more"><span>MORE</span><img src="@/assets/arrow8.png"></div>
            </div>
          </div>
          <div class="food_item food_item3" @click="toPageHref('/catering',3)">
            <div class="pic" :style="{'background-image': 'url(' + foodList[2].pic + ')' }"></div>
            <div class="bottom">
              <div class="name">{{ foodList[2].name }}</div>
              <div class="more"><span>MORE</span><img src="@/assets/arrow8.png"></div>
            </div>
          </div>
          <div class="food_item food_item4" @click="toPageHref('/catering',3)">
            <div class="pic" :style="{'background-image': 'url(' + foodList[3].pic + ')' }"></div>
            <div class="bottom">
              <div class="name">{{ foodList[3].name }}</div>
              <div class="more"><span>MORE</span><img src="@/assets/arrow8.png"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shop">
      <div class="pao pao_green shop_pao wow" data-wow-offset="-100000"></div>
      <div class="linear_word">SHOPPING</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">特享购物</div>
      </div>
      <div class="index19"></div>
      <div class="shop_list_p wow shopOpen2">
        <div class="shop_list">
          <div class="left wow shopOpen">
            <div class="shop_item shop_item1"></div>
            <div class="shop_item shop_item2"></div>
            <div class="shop_item shop_item3"></div>
          </div>
          <div>
            <div class="shop_item shop_item4"></div>
          </div>
        </div>
        <div class="right">
          <div class="name">开放式商业街区</div>
          <div class="detail">拥有港湾影城、港湾美食街、电玩城、飞行家挑战基地、VR体验馆和婚纱摄影馆等数十种业态服务，为游客带来“吃、住、游、购、娱”一体的休闲娱乐新体验。</div>
          <div class="more" @click="$toPage('/shopping')"><span>MORE</span><img src="@/assets/arrow8.png"></div>
        </div>
      </div>
    </div>
    <div class="xcmhotel_p">
      <div class="pao pao_green hotel_pao wow" data-wow-offset="-100000"></div>
      <div class="drops">
        <div class="drop wow" :data-wow-delay="dropFilter(k)" data-wow-offset="-100000" v-for="(v, k) in 128" :key="k"></div>
      </div>
      <div class="xcmhotel wow fadeIn">
        <div class="xcmhotel_img"></div>
        <div class="xcmhotel_main">
          <img class="xcmhotel_logo" src="@/assets/logo4.png">
          <div class="xcmhotel_dec">熊出没主题亲子休闲度假型酒店，地理位置优越，交通便捷，是旅游、度假、商务、会议、休闲娱乐的理想之地。</div>
          <div class="more1" @click="$toPage('https://hotel.fangte.com/ningbo/')">
            进入官网
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- share -->
    <div class="code_box">
      <div class="code_box_item">
        <img class="code1 animated" src="@/assets/ft.png" alt="" srcset="">
        <img class="code2" src="@/assets/ft_code.png" alt="" srcset="" style="display: none; top: 20px; opacity: 0;">
      </div>
      <div class="code_box_item">
        <img class="code1 animated" src="@/assets/weixin.png" alt="" srcset="">
        <img class="code2" src="@/assets/wx_qr.jpg" alt="" srcset="" style="display: none; top: 20px; opacity: 0;">
      </div>
      <div class="code_box_item">
        <img class="code1 animated" src="@/assets/wb.png" alt="" srcset="">
        <img class="code2" src="@/assets/wb_qr.jpg" alt="" srcset="" style="display: none; top: 20px; opacity: 0;">
      </div>
      <div class="code_box_item">
        <img class="code1 animated" src="@/assets/tel.png" alt="" srcset="">
        <div class="code2 tel">
          <p>服务热线</p>
          <span>400-166-0006</span>
        </div>
        <!-- <img  src="@/assets/tel_code.png" alt="" srcset="" style="display: none; top: 20px; opacity: 0;"> -->
      </div>
    </div>
    <myBottom></myBottom>

  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
import { getWebData } from '@/request/api';
// import P from '@/tools/project';

export default {
  data() {
    return {
      entertainmentList: [{
        name: '熊熊乐园',
        detail: '以同名动画IP为背景打造的儿童室内乐园。',
        pic: require('@/assets/entertainment1.png'),
        picBg: require('@/assets/entertainment1_1.png'),
        picBg2: require('@/assets/entertainment1_2.png'),
        delay: 2,
        index: 1
      }, {
        name: '港湾影城',
        detail: '以“熊出没”IP为元素的全特效高级影院。',
        pic: require('@/assets/entertainment2.png'),
        picBg: require('@/assets/entertainment2_1.png'),
        picBg2: require('@/assets/entertainment2_2.png'),
        delay: 1,
        index: 4
      }, {
        name: '熊熊小火车博物馆',
        detail: '和熊大熊二一起乘坐蒸汽小火车，踏上熊湾奇幻探险之旅。',
        pic: require('@/assets/entertainment3.png'),
        picBg: require('@/assets/entertainment3_1.png'),
        picBg2: require('@/assets/entertainment3_2.png'),
        delay: 0,
        index: 3
      }, {
        name: '飞行家挑战基地',
        detail: '利用空气动力学原理，让游客体验失重的感觉，感受飞翔的刺激。',
        pic: require('@/assets/entertainment4.png'),
        picBg: require('@/assets/entertainment4_1.png'),
        picBg2: require('@/assets/entertainment4_2.png'),
        delay: 4,
        index: 5
      }, {
        name: '潮玩馆',
        detail: '电玩城配备多种潮流游戏，满足游客的娱乐需求。',
        pic: require('@/assets/entertainment5.png'),
        picBg: require('@/assets/entertainment5_1.png'),
        picBg2: require('@/assets/entertainment5_2.png'),
        delay: 3,
        index: 2
      },],
      activitieIndex: 6,
      activitieLeft: 0,
      activitieAnimating: false,
      activitieList: [{},{},{},{},{},{},{},{},{},{}],
      foodList: [{
        name: '港湾美食街',
        pic: require('@/assets/food1.png'),
      }, {
        name: '熊二汉堡',
        pic: require('@/assets/food2.png'),
      }, {
        name: '阿国饭店',
        pic: require('@/assets/food3.png'),
      }, {
        name: '土耳其餐厅',
        pic: require('@/assets/food4.png'),
      },],
      myPopupShow: false,
    }
  },
  methods: {
    openPoP() {
      $('.noOpen').addClass('myPopup_box_show')
    },
    //锚点定位版本
    toPageHref(url, k) {
      this.$router.push({
        path: url,
        query: {
          id: k,
        }
      })
    },
    getThemeList() {
      P_getNewsList({
        park_id: this.$ParkId,
        news_type: 4,
        pageIndex: 1,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          res.data.map(item => {
            item.news_bigpic = item.news_bigpic || item.news_smallpic
            item.news_time = this.$time(item.news_time)
          });
          res = res.data
          var repeat = JSON.parse(JSON.stringify(res));
          if (res.length == 1) {
            res.push([]);
            res.push([]);
            res.push([]);
          } else if (res.length == 2) {
            res = res.concat(JSON.parse(JSON.stringify(repeat)));
            res = res.concat(JSON.parse(JSON.stringify(repeat)));
          } else if (res.length == 3 || res.length == 4) {
            res = res.concat(JSON.parse(JSON.stringify(repeat)));
          }
          this.activitieList = res;
        } else {
          this.activitieList = [];
        }
      })
    },
    activitieChange(el) {
      if (this.activitieAnimating || $(el).hasClass('activities_item_active')) {
        return;
      }
      this.activitieAnimating = true;
      $('.activities_item').removeClass('activities_item_active');
      $(el).addClass('activities_item_active');
      var prevDom = $(el).prevAll();
      this.activitiesControl(prevDom.length, 1);
      setTimeout(() => {
        this.$refs.wrapper.style.transition = `all 0s`;
        for (let i = prevDom.length - 1; i >= 0; i--) {
          $('.activities_list .wrapper').append(prevDom.eq(i).clone(true));
        }
        prevDom.remove();
        this.activitieLeft = 0;
        this.activitieAnimating = false;
      }, 1000);
    },
    activitiesControl(index, speed = 0.5) {
      this.$refs.wrapper.style.transition = `all ${speed}s`;
      let left = this.activitieLeft + index * 366 * -1;
      this.activitieLeft = left;
      this.activitieIndex = index
    },
    dropFilter(k) {
      var row = Math.floor(k % 8);
      var col = Math.floor(k / 8);
      var time = (col > row ? col : row) * 0.1;
      return time + 's';
    },
    // 视频
    setVideo() {
      $('#video').on('pause', function () {
        $('.video_btn').css('display', 'block');
        $('.video_gray').css('display', 'block');
      });
      $('#video').on('play', function () {
        $('.video_btn').css('display', 'none');
        $('.video_gray').css('display', 'none');
      });
    },
    setWow() {
      $('.entertainment_item1').addClass('slideInUp');
      $('.entertainment_item').css('transform', 'translate(-20000px, 0)');
      $('.drops').css('transform', 'translate(-20000px, 0)');
      $('.pao_green').css('transform', 'translate(-20000px, 0)');
      $('.entertainment .tip').css('transform', 'translate(-20000px, 0)');
      $(".btn_list .left, .btn_list .right").css('transform', 'translate(-20000px, 0)');
      $('.pao3').css('transform', 'translate(-20000px, 0)');
      $('.exploring_item').css('transform', 'translate(-20000px, 0)');
    },
    initShare() {
      $(window).scroll(function () {
        if ($(window).scrollTop() > 400) {
          $('.code_box').addClass('animated  bounceInRight')
          $('.code_box').removeClass('bounceOutRight')
        } else {
          if ($('.code_box').hasClass('animated')) {
            $('.code_box').addClass('animated bounceOutRight')
            $('.code_box').removeClass('bounceInRight')
          }
        }
      });
      $('.code_box .code_box_item').mouseenter(function (params) {
        $(this).find('.code1').addClass('animated   swing')
        $(this).find('.code2').show()
        $(this).find('.code2').animate({
          top: '-20px',
          opacity: 1
        })
      })
      $('.code_box .code_box_item').mouseleave(function (params) {
        $(this).find('.code1').removeClass(' swing')
        $(this).find('.code2').hide()
        $(this).find('.code2').animate({
          top: '20px',
          opacity: 0
        })
      })
    },
    initWow(zoom) {
      var top = $('.xcmhotel_main').offset().top;
      var offset = zoom >= 1 ? 400 * zoom : (400 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            // 首屏
            if (box.className.includes('mainPic')) {
              $('.pao3').css('transform', 'translate(0, 0)');
              $('.pao3').addClass('rotateInDownRightLittle');
            }
            // 探索欢乐
            if (box.className.includes('exploring_item1')) {
              $('.exploring_item').css('transform', 'translate(0, 0)');
            }
            // 视频
            if (box.className.includes('video_box')) {
              $('.exploring .drops').css('transform', 'translate(0, 0)');
              $('.exploring .drop').addClass('zoomIn');
              setTimeout(() => {
                $('.video_pao').css('transform', 'translate(0, 0)');
                $('.video_pao').addClass('slideInRight');
              }, 900);
            }
            // 休闲娱乐
            if (box.className.includes('flipInX')) {
              $('.entertainment .tip').css('transform', 'translate(0, 0)');
              $('.entertainment .tip').addClass('slideInUpLittle');
            }
            if (box.className.includes('entertainment_item1')) {
              $('.entertainment_item').css('transform', 'translate(0, 0)');
              $('.entertainment_item').addClass('slideInUp');
              setTimeout(() => {
                $('.entertainment_pao').css('transform', 'translate(0, 0)');
                $('.entertainment_pao').addClass('slideInLeft');
              }, 1200);
            }
            // 精彩活动
            if (box.className.includes('activities_item1')) {
              setTimeout(() => {
                $('.activities_item').eq(0).addClass('activities_item_active');
                $(".btn_list .left, .btn_list .right").css('transform', 'translate(0, 0)');
                $('.btn_list .left').addClass('rollInLeft');
                $('.btn_list .right').addClass('rollInRight');
              }, 1500);
            }
            // 特享购物
            if (box.className.includes('shop_list_p')) {
              setTimeout(() => {
                $('.shop_pao').css('transform', 'translate(0, 0)');
                $('.shop_pao').addClass('slideInRight');
              }, 400);
            }
            // 酒店
            if (box.className.includes('xcmhotel')) {
              $('.xcmhotel_img').addClass('xcmhotel_img_active');
              $('.xcmhotel_p .drops').css('transform', 'translate(0, 0)');
              $('.xcmhotel_p .drop').addClass('zoomIn');
              $('.hotel_pao').css('transform', 'translate(0, 0)');
              $('.hotel_pao').addClass('slideInLeft');
            }
            // $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
  },
  components: {
    myMenu, myBottom
  },
  mounted() {
    this.setVideo();
    this.setWow();
    this.initShare();
    var that = this;
    $(function () {
      $('.activities_item').click(function () {
        if ($(this).hasClass('activities_item_empty')) {
          return;
        }
        that.activitieChange(this);
      });
    })
    this.getThemeList()
    var that = this
    $(document).on('click', '.activities_list .btn', function (event) {
      event.stopPropagation()
      var n = $(this).attr('data-id')
      var v = that.activitieList[n];
      that.$toPage(v.news_redirect || '/themeDetail', {id: v.news_id})
      event.preventDefault()
    })
  }
}
</script>

<style lang="scss" scoped>
#index {
  background: url('@/assets/index13.png') no-repeat;
  background-position: left 1395px;
}
.ware {
  background-size: auto 100%;
  background-position: 0 86px;
  background-repeat: repeat-x;
  background-clip: text;
  color: #000;
  color: transparent;
}
.mainPic {
  position: absolute;
  right: 0;
  top: 20px;
}
.mainPic2 {
  position: absolute;
  right: 0;
  top: 945px;
  pointer-events: none;
  user-select: none;
}
.pao_green {
  background: rgb(184, 242, 211);
  background: -moz-linear-gradient(
    -20deg,
    rgb(184, 242, 211) 13%,
    rgb(254, 253, 168) 100%
  );
  background: -webkit-linear-gradient(
    -20deg,
    rgb(184, 242, 211) 13%,
    rgb(254, 253, 168) 100%
  );
  background: -ms-linear-gradient(
    -20deg,
    rgb(184, 242, 211) 13%,
    rgb(254, 253, 168) 100%
  );
  background: linear-gradient(
    -20deg,
    rgb(184, 242, 211) 13%,
    rgb(254, 253, 168) 100%
  );
  border-radius: 50%;
}
.pao1 {
  left: 0;
  top: 202px;
}
.pao2 {
  left: 738px;
  top: 215px;
}
.pao3 {
  right: 33px;
  top: 827px;
}
.pao_trends {
  width: 400px;
  height: 400px;
  background: rgb(162, 220, 180);
  background: -moz-linear-gradient(
    160deg,
    rgb(162, 220, 180) 20%,
    rgb(230, 243, 166) 80%
  );
  background: -webkit-linear-gradient(
    160deg,
    rgb(162, 220, 180) 20%,
    rgb(230, 243, 166) 80%
  );
  background: -o-linear-gradient(
    160deg,
    rgb(162, 220, 180) 20%,
    rgb(230, 243, 166) 80%
  );
  background: -ms-linear-gradient(
    160deg,
    rgb(162, 220, 180) 20%,
    rgb(230, 243, 166) 80%
  );
  background: linear-gradient(
    250deg,
    rgb(162, 220, 180) 20%,
    rgb(230, 243, 166) 80%
  );
  opacity: 0.85;
  right: -200px;
  top: 700px;
  animation: pao_trends 6s ease-in-out infinite,
    pao_trends2 16s linear infinite forwards;
  overflow: hidden;
}
.pao_trends2 {
  width: 300px;
  height: 300px;
  left: 874px;
  top: 660px;
  background: #feebc6;
  background: -moz-linear-gradient(
    160deg,
    #feebc6 20%,
    rgba($color: #feebc6, $alpha: 0.2) 80%
  );
  background: -webkit-linear-gradient(
    160deg,
    #feebc6 20%,
    rgba($color: #feebc6, $alpha: 0.2) 80%
  );
  background: -o-linear-gradient(
    160deg,
    #feebc6 20%,
    rgba($color: #feebc6, $alpha: 0.2) 80%
  );
  background: -ms-linear-gradient(
    160deg,
    #feebc6 20%,
    rgba($color: #feebc6, $alpha: 0.2) 80%
  );
  background: linear-gradient(
    250deg,
    #feebc6 20%,
    rgba($color: #feebc6, $alpha: 0.2) 80%
  );
}
@keyframes pao_trends {
  0% {
    border-radius: 56% 42% 42% 42%;
  }

  25% {
    border-radius: 60% 40% 40% 40%;
  }

  50% {
    border-radius: 64% 44% 44% 44%;
  }

  75% {
    border-radius: 60% 40% 40% 40%;
  }

  100% {
    border-radius: 56% 42% 42% 42%;
  }
}
@keyframes pao_trends2 {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.aboutpack {
  width: 1320px;
  margin: 130px auto 0;
  position: relative;
  .parkname_en {
    font-size: 74px;
    color: #784100;
    font-family: HKGroteskSemiBold;
  }
  .parkname_cn {
    display: inline-block;
    font-size: 70px;
    font-family: SourceBold;
    overflow: hidden;
    margin-top: -10px;
    .line {
      height: 1px;
      background: #f97f24;
    }
  }
  .detail {
    font-size: 24px;
    color: #1f1f1f;
    line-height: 1.8;
    width: 588px;
    margin-top: 14px;
    text-indent: 2em;
  }
  
}
.more1 {
  transition: all 0.4s;
  width: 163px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  border-radius: 999px;
  background: rgb(234, 94, 62);
  background: -moz-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -webkit-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -o-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -ms-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: linear-gradient(
    120deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  color: #fff;
  font-size: 24px;
  letter-spacing: 3px;
  text-indent: 3px;
  cursor: pointer;
  margin-top: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 36px;
  -webkit-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  -moz-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  span {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fd9424;
    font-size: 0;
    font-weight: bold;
    transition: all 0.4s;
    margin-left: 0;
    transform: translate(14px, 0) scale(0);
    transform-origin: left center;
    background: #fff url('~@/assets/arrow10.png') no-repeat;
    background-size: 18px auto;
    background-position: center center;
  }
  &:hover {
    padding-left: 0;
    span {
      opacity: 1;
      transform: translate(14px, 0) scale(1);
    }
  }
}
.exploring {
  width: 1320px;
  margin: 270px auto 0;
  position: relative;
  .drops {
    position: absolute;
    left: 0;
    top: 824px;
    width: 240px;
    font-size: 0;
    .drop {
      width: 9px;
      height: 9px;
      background: #ffa147;
      border-radius: 50%;
      display: inline-block;
      margin-right: 18px;
      margin-bottom: 18px;
    }
  }
  .video_pao {
    width: 290px;
    height: 290px;
    right: -400px;
    top: 1164px;
  }
  .exploring_item {
    width: 617px;
    height: 297px;
    display: inline-block;
    margin-top: 50px;
    position: relative;
    color: #fff;
    cursor: pointer;
    .bg {
      border-radius: 26px;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transform-origin: bottom;
      transition: 0.6s;
      padding: 30px 28px;
      transform: perspective(900px) translateY(0) rotateX(0) translateZ(0);
    }
    .cover {
      font-size: 0;
      pointer-events: none;
      position: absolute;
      transition: 0.6s;
    }
    .title {
      font-size: 42px;
      font-family: SourceBold;
      letter-spacing: 2px;
      text-indent: 2px;
    }
    .detail {
      font-size: 20px;
      text-indent: 2em;
      width: 310px;
      margin-top: 10px;
    }
    .btn {
      width: 177px;
      height: 46px;
      border-radius: 999px;
      background: #fff;
      text-align: center;
      line-height: 46px;
      font-size: 24px;
      font-family: SourceBold;
      margin-top: 24px;
      position: absolute;
      left: 30px;
      top: 200px;
      transition: 0.6s;
      img {
        width: 18px;
      }
    }
    &:hover {
      .cover {
        transform: translate(-20px, 0) scale(1.2);
      }
      .bg {
        transform: perspective(900px) translateY(0) rotateX(25deg) translateZ(0);
      }
      .btn {
        transform: translate(0, 6px);
        img {
          animation: exploring_btn 0.6s ease-in-out infinite;
        }
      }
    }
  }
  .exploring_item1 {
    z-index: 1;
    .bg {
      box-shadow: 0 10px 20px 0 rgba(244, 87, 1, 0.3);
      background: url('@/assets/index7.png');
    }
    .cover {
      top: -15px;
      right: -60px;
    }
    .btn {
      color: #d75e00;
      box-shadow: 0 1px 9px 0 rgba(238, 115, 34, 0.5);
    }
    &:hover {
      .cover {
        transform: translate(0, -14px) scale(1.1);
      }
      .cover img {
        animation: float_water 2s 0.6s ease-in-out infinite;
      }
      .btn {
        box-shadow: 0 1px 9px 0 rgba(238, 115, 34, 1);
      }
    }
  }
  .exploring_item2 {
    float: right;
    .bg {
      box-shadow: 0 10px 20px 0 rgba(20, 153, 255, 0.5);
      background: url('@/assets/index9.png');
    }
    .cover {
      top: -30px;
      right: -48px;
      transform-origin: center center;
      img {
        transform: rotate(2deg);
      }
    }
    .btn {
      color: #0964b9;
      box-shadow: 0 1px 9px 0 rgba(0, 125, 222, 0.5);
    }
    &:hover {
      .cover img {
        animation: float_water2 2s 0.6s ease-in-out infinite;
      }
      .btn {
        box-shadow: 0 1px 9px 0 rgba(0, 125, 222, 1);
      }
    }
  }
  @keyframes float_water {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(-10px, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }
  @keyframes float_water2 {
    0% {
      transform: rotate(2deg);
    }
    50% {
      transform: rotate(-2deg);
    }
    100% {
      transform: rotate(2deg);
    }
  }
  @keyframes exploring_btn {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(4px, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }
  .video_box {
    width: 1118px;
    height: 626px;
    border-radius: 20px;
    margin: 244px auto 0;
    position: relative;
    cursor: pointer;
    .video {
      width: 100%;
      height: 100%;
      box-shadow: 0 3px 24px 0 rgba(69, 86, 131, 0.4);
      border: 1px solid #fff;
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center bottom;
        border-radius: 20px;
      }
      .video_gray {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 7, 63, 0.5);
        pointer-events: none;
        z-index: 1;
        border-radius: 20px;
      }
    }
    .xiong {
      position: absolute;
      pointer-events: none;
      z-index: 2;
    }
    .xiong1 {
      top: -82px;
      right: -44px;
      z-index: 2;
    }
    .xiong2 {
      top: -178px;
      right: 0px;
      z-index: 2;
    }
    .video_btn {
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(1);
      pointer-events: none;
      z-index: 1;
    }
    .video_btn1 {
      width: 98px;
      height: 98px;
      background: rgba(255, 255, 255, 0.4);
      animation: scaleBtn 1.5s ease-in-out infinite;
    }
    .video_btn2 {
      width: 72px;
      height: 72px;
      background: #fff;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    @keyframes scaleBtn {
      0% {
        width: 72px;
        height: 72px;
      }
      50% {
        width: 98px;
        height: 98px;
      }
      100% {
        width: 72px;
        height: 72px;
      }
    }
  }
}
.entertainment {
  width: 1320px;
  margin: 250px auto 910px;
  position: relative;
  .entertainment_pao {
    left: -440px;
    bottom: -800px;
    width: 220px;
    height: 220px;
  }
  .tag {
    width: 136px;
    height: 14px;
    line-height: 73px;
    text-align: center;
    background: #ffbd49;
    border-radius: 4px;
    font-size: 48px;
    color: #fff;
    letter-spacing: 2px;
    text-indent: 2px;
  }
  .tip {
    text-indent: 2em;
    width: 400px;
    line-height: 1.7;
    margin-top: 26px;
  }
  .entertainment_item {
    position: absolute;
    cursor: pointer;
    .pic_box {
      background: #fff;
      display: inline-block;
      border-radius: 25px;
      transition: all 0.6s;
    }
    .pic {
      width: 376px;
      height: 458px;
      object-fit: cover;
      object-position: center center;
      border-radius: 25px;
      border: 1px solid #fff;
      transition: all 0.6s;
    }
    .main_p {
      position: absolute;
      z-index: 999;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    .main {
      width: 432px;
      height: 285px;
      background-repeat: no-repeat;
      position: relative;
      margin-top: 300px;
      margin-left: 10px;
      color: #fff;
      padding: 66px 60px 0;
      transition: all 0.6s;
      transform: perspective(900px) translateY(0) rotateX(0) translateZ(0);
    }
    .name {
      font-size: 41px;
      font-family: SourceBold;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      display: inline-block;
      padding-bottom: 2px;
      word-break: keep-all;
    }
    .detail {
      font-size: 21px;
      text-indent: 2em;
      margin-top: 6px;
      // letter-spacing: -1px;
    }
    .btn {
      width: 102px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 999px;
      border: 1px solid #fff;
      font-size: 14px;
      margin-top: 14px;
      cursor: pointer;
      span {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-image: url('~@/assets/arrow5.png');
        background-size: 10px auto;
        background-position: left top;
        margin-left: 4px;
        transition: all 0.6s;
      }
    }
    .pic2_box {
      position: absolute;
      transition: all 0.6s;
      font-size: 0;
      img {
        transition: all 0.6s;
        width: 0px;
        opacity: 0;
        max-width: unset;
      }
    }
    &:hover {
      .btn {
        span {
          background-position: 10px top;
        }
      }
      .pic2_box {
        img {
          opacity: 1;
        }
      }
      .pic_box {
        transform: translate(36px, 20px);
      }
      .pic {
        opacity: 0.6;
      }
      .main {
        transform: perspective(900px) translateY(-5%) rotateX(25deg)
          translateZ(0);
      }
    }
  }
  .entertainment_item1 {
    .pic2_box {
      left: 200px;
      top: 200px;
    }
    &:hover {
      .pic2_box {
        left: 16px;
        top: -76px;
        img {
          width: 440px;
        }
      }
    }
  }
  .entertainment_item2 {
    .pic2_box {
      left: 200px;
      top: 200px;
    }
    &:hover {
      .pic2_box {
        left: 86px;
        top: -54px;
        img {
          width: 358px;
        }
      }
    }
  }
  .entertainment_item3 {
    .name{
      font-size: 39px;
    }
    .pic2_box {
      left: 200px;
      top: 250px;
    }
    &:hover {
      .pic2_box {
        left: 46px;
        top: -34px;
        img {
          width: 349px;
        }
      }
    }
  }
  .entertainment_item4 {
    .pic2_box {
      left: 200px;
      top: 280px;
    }
    .detail{
      width: 320px;
      text-indent: 1em;
      margin-left: -10px;
    }
    &:hover {
      .pic2_box {
        left: 2px;
        top: 34px;
        img {
          width: 443px;
        }
      }
    }
  }
  .entertainment_item5 {
    .pic2_box {
      left: 200px;
      top: 180px;
    }
    &:hover {
      .pic2_box {
        left: 84px;
        top: -56px;
        img {
          width: 369px;
        }
      }
    }
  }
  .entertainment_item1 {
    left: 0;
    top: 530px;
  }
  .entertainment_item2 {
    left: 470px;
    top: 160px;
  }
  .entertainment_item3 {
    left: 946px;
    top: 20px;
  }
  .entertainment_item4 {
    left: 470px;
    top: 766px;
  }
  .entertainment_item5 {
    left: 946px;
    top: 626px;
  }
}
.activities {
  width: 100%;
  background: url('@/assets/index17.png') no-repeat;
  text-align: center;
  margin-top: 10px;
  padding-top: 112px;
  padding-bottom: 140px;
  .linear_word {
    background: #ffdbb0;
    background: -moz-linear-gradient(#ffdbb0, rgba(255, 255, 255, 0) 78%);
    background: -webkit-linear-gradient(#ffdbb0, rgba(255, 255, 255, 0) 78%);
    background: -o-linear-gradient(#ffdbb0, rgba(255, 255, 255, 0) 78%);
    background: -ms-linear-gradient(#ffdbb0, rgba(255, 255, 255, 0) 78%);
    background: linear-gradient(#ffdbb0, rgba(255, 255, 255, 0) 78%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .no_list {
    width: 1320px;
    margin: 20px auto 0;
    height: 630px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 20px;
    box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
    background: rgba(255, 255, 255, 1);
    span {
      color: #999;
      margin-top: -162px;
      font-size: 20px;
    }
  }
  .activities_list {
    height: 630px;
    white-space: nowrap;
    position: relative;
    margin-left: 278px;
    overflow: hidden;
    .wrapper {
      padding-top: 70px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .activities_item {
    width: 336px;
    height: 522px;
    border-radius: 26px;
    box-shadow: 0 10px 20px 0 rgba($color: #e8a02e, $alpha: 0.38);
    display: inline-block;
    margin-left: 14px;
    margin-right: 16px;
    position: relative;
    cursor: pointer;
    transition: all 1s;
    background: #fff;
    transform: rotate(0);
    .main {
      width: 384px;
      height: 100%;
      position: absolute;
      right: 28px;
      top: 0;
      color: #1f1f1f;
      white-space: wrap;
      white-space: pre-wrap;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: all 1s;
      opacity: 0;
      // pointer-events: none;
      .m_name {
        font-size: 38px;
        /* font-family: SourceBold; */
        overflow: hidden;
        text-overflow: ellipsis;
        width: -moz-fit-content;
        width: fit-content;
        padding-bottom: 5px;
        margin-bottom: 10px;
        letter-spacing: 0px;
        font-weight: 600;
        padding-right: 14px;
      }
      .m_time {
        margin-top: 10px;
        margin-bottom: 24px;
        span {
          font-size: 20px;
          vertical-align: middle;
        }
      }
      .m_detail {
        font-size: 26px;
        text-indent: 2em;
        line-height: 1.8em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .m_tag {
        font-size: 0;
        div {
          font-size: 20px;
          color: #fff;
          background-color: #f98024;
          border-radius: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-right: 11px;
          padding: 0 14px;
          display: inline-block;
        }
      }
    }
    .cover {
      width: 336px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 1px solid #fff;
      border-radius: 27px;
      overflow: hidden;
      transition: all 0.3s;
      transform: rotate(0);
    }
    .pic_after {
      width: 100%;
      height: 100%;
      background-position: center center;
      background-size: cover;
      position: absolute;
      border-radius: 27px;
    }
    .cover_before {
      width: 100%;
      height: 200%;
      position: absolute;
      top: 0;
      transition: all 0.8s;
      top: -50%;
      transform: rotate(0);
      opacity: 1;
    }
    .pic_before {
      width: 100%;
      height: 203px;
      background-position: center bottom;
      background-size: 100% auto;
      position: absolute;
      opacity: 0.5;
      bottom: 0;
      transition: all 1s;
      background-image: url('../assets/activities1_1.png');
    }
    .name {
      position: relative;
      font-size: 42px;
      color: #fff;
      font-family: SourceBold;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: all 1s;
      .icon {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        border: 1px solid #fff;
        transform: rotate(45deg);
        margin-top: 56px;
        margin-bottom: 14px;
        font-size: 0;
        &::before {
          content: '';
          display: inline-block;
          width: 100%;
          height: 100%;
          background: #fff;
          border-radius: 4px;
          transform: translate(-6px, -6px);
          transition: all 0.3s;
        }
      }
      span:last-child {
        line-height: 46px;
        white-space: normal;
        display: inline-block;
        text-align: left;
        margin-top: 18px;
        transition: all 0.3s;
        font-size: 28px;
        writing-mode: vertical-lr;
        height: 348px;
      }
    }
    &:hover {
      .name {
        span:last-child {
          transform: translate(0, -10px);
        }
        .icon {
          &::before {
            margin-top: 6px;
            margin-left: 6px;
          }
        }
      }
    }
  }
  .activities_item_empty{
    cursor: auto;
    .icon{
      display: none !important;
    }
  }
  .activities_item1 .cover_before {
    background: linear-gradient(
      rgba(28, 82, 192, 0) 5%,
      rgb(28, 82, 192) 27%,
      rgb(28, 82, 192) 29%,
      rgb(191, 248, 255) 75%
    );
  }
  .activities_item2 .cover_before {
    background: linear-gradient(
      rgba(238, 98, 67, 0) 5%,
      rgb(238, 98, 67) 27%,
      rgb(238, 98, 67) 31%,
      rgb(253, 169, 101) 75%
    );
  }
  .activities_item3 .cover_before {
    background: linear-gradient(
      rgba(62, 140, 247, 0) 5%,
      rgb(62, 140, 247) 27%,
      rgb(62, 140, 247) 31%,
      rgb(103, 239, 234) 69%
    );
  }
  .activities_item4 .cover_before {
    background: linear-gradient(
      rgba(114, 94, 218, 0) 5%,
      rgb(114, 94, 218) 27%,
      rgb(114, 94, 218) 42%,
      rgb(252, 130, 130) 98%
    );
  }
  .activities_item_active {
    width: 826px;
    cursor: default;
    .main {
      transition: all 1s 0.5s;
      opacity: 1;
    }
    .cover {
      left: 38px;
      top: -58px;
      pointer-events: none;
    }
    .cover_before {
      top: 100%;
      opacity: 0;
    }
    .pic_before {
      opacity: 0;
    }
    .name {
      opacity: 0;
    }
  }
  .btn_list {
    text-align: right;
    padding-right: 292px;
  }

  .btn {
    width: 68px;
    height: 68px;
    border-radius: 999px;
    box-shadow: 0px 3px 24px 0px rgba(230, 132, 26, 0.38);
    background-color: #fff;
    display: inline-block;
    margin-top: 70px;
    margin-right: 14px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    font-weight: normal;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: linear-gradient(
        150deg,
        rgb(241, 87, 53) 0%,
        rgb(255, 152, 18) 100%
      );
      opacity: 0;
      transition: all 0.3s;
    }
    .arrow1,
    .arrow2 {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      transition: all 0.3s;
      height: 29px;
    }
    .arrow1 {
      width: 15px;
      background-image: url('~@/assets/arrow6.png');
      opacity: 1;
    }
    .arrow2 {
      width: 83px;
      background-image: url('~@/assets/arrow7.png');
      opacity: 0;
    }
  }
  .btn_able {
    &:hover {
      width: 136px;
      &::before {
        opacity: 1;
      }
      .arrow1 {
        opacity: 0;
      }
      .arrow2 {
        opacity: 1;
      }
    }
  }
  .left {
    .arrow1,
    .arrow2 {
      left: 25px;
      transform: translate(0, -50%) rotateY(180deg);
    }
  }
  .right {
    .arrow1,
    .arrow2 {
      right: 25px;
    }
  }
  .btn_disable {
    pointer-events: none;
    .arrow1 {
      background-image: url('~@/assets/arrow9.png');
    }
  }
}
.food {
  width: 1320px;
  margin: 40px auto 0;
  .food_list {
    margin-top: 48px;
    display: flex;
    justify-content: space-between;
    .right {
      width: 573px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  .food_item {
    border-radius: 26px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    .pic {
      width: 100%;
      height: 100%;
      background-size: 100% auto;
      background-position: center center;
      transition: all 0.6s;
    }
    .bottom {
      width: 100%;
      color: #fff;
      font-size: 18px;
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba($color: #4b1601, $alpha: 0.5);
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 36px;
      border-radius: 0 0 26px 26px;
    }
    .more {
      font-size: 10px;
      width: 68px;
      line-height: 22px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 999px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        vertical-align: middle;
      }
      img {
        width: 9px;
        height: 9px;
        vertical-align: middle;
        margin-left: 2px;
        transition: all 0.6s;
      }
    }
    &:hover {
      .pic {
        background-size: 105% auto;
      }
      img {
        transform: translate(4px, 0);
      }
    }
  }
  .food_item1 {
    width: 722px;
    height: 454px;
    .bottom {
      font-size: 40px;
      height: 120px;
      padding: 0 70px;
    }
    .more {
      width: 163px;
      line-height: 52px;
      font-size: 22px;
      img {
        width: 21px;
        height: 21px;
        margin-left: 10px;
      }
    }
    &:hover {
      img {
        transform: translate(10px, 0);
      }
    }
  }
  .food_item2,
  .food_item3 {
    width: 274px;
    height: 226px;
  }
  .food_item4 {
    width: 573px;
    height: 204px;
    align-self: flex-end;
    .pic {
      background-size: 101% auto;
    }
  }
}
.shop {
  width: 1320px;
  margin: 54px auto 266px;
  position: relative;
  .index19{
    background: url('@/assets/index19.png') no-repeat;
    background-size: 100% 100%;
    width: 1920px;
    height: 1002px;
    position: absolute;
    left: -300px;
    top: 350px;
  }
  .shop_pao {
    width: 220px;
    height: 220px;
    right: -370px;
    top: 0;
  }
  .shop_list_p {
    position: relative;
    margin-top: 44px;
  }
  .shop_list {
    display: flex;
    justify-content: space-between;
    border-radius: 26px;
    overflow: hidden;
    .left {
      width: 516px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  .shop_item {
    background-position: center center;
    background-size: cover;
  }
  .shop_item1 {
    background-image: url('@/assets/shop1.png');
    width: 516px;
    height: 230px;
    border-radius: 26px 0 0 0;
  }
  .shop_item2 {
    background-image: url('@/assets/shop2.png');
    width: 260px;
    height: 218px;
    border-radius: 0 0 0 26px;
    align-self: flex-end;
  }
  .shop_item3 {
    background-image: url('@/assets/shop3.png');
    width: 250px;
    height: 218px;
    border-radius: 0 0 0 0;
    align-self: flex-end;
  }
  .shop_item4 {
    background-image: url('@/assets/shop4.jpg');
    width: 798px;
    height: 454px;
    border-radius: 0 26px 26px 0;
    background-position: -255px -120px;
    background-size: 130%;
  }
  .right {
    width: 542px;
    height: 475px;
    box-shadow: 0px 6px 23.52px 0.48px rgba(152, 54, 1, 0.4);
    border-radius: 26px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    background: url('@/assets/shop5.png');
    color: #fff;
    padding: 0 74px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .name {
      font-family: SourceBold;
      font-size: 42px;
      margin-top: 10px;
    }
    .detail {
      font-size: 26px;
      line-height: 1.8;
      text-indent: 2em;
      margin-top: 16px;
    }
    .more {
      width: 148px;
      line-height: 46px;
      border: 2px solid #fff;
      border-radius: 999px;
      text-align: center;
      font-size: 22px;
      cursor: pointer;
      align-self: flex-end;
      margin-top: 28px;
      img {
        margin-left: 9px;
        width: 18px;
        transition: all 0.6s;
      }
      &:hover {
        img {
          transform: translate(6px, 0);
        }
      }
    }
  }
}

.xcmhotel_p{
  width: 1320px;
  margin: 54px auto 126px;
  position: relative;
  .hotel_pao {
    width: 285px;
    height: 285px;
    left: -430px;
    top: -200px;
  }
  .drops {
    position: absolute;
    right: -116px;
    top: -72px;
    width: 240px;
    font-size: 0;
    .drop {
      width: 9px;
      height: 9px;
      background: #ffa147;
      border-radius: 50%;
      display: inline-block;
      margin-right: 18px;
      margin-bottom: 18px;
    }
  }
  .xcmhotel_img{
    border-radius: 26px;
    width: 819px;
    height: 485px;
    background: url('@/assets/index18.png') no-repeat;
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    transition: all .6s ease-in-out;
  }
  .xcmhotel_img_active{
    left: -92px;
    top: -46px;
  }
  .xcmhotel{
    border-radius: 26px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 12px 98px 0px rgba(232, 160, 46, 0.38);
    width: 1228px;
    height: 500px;
    float: right;
    position: relative;
  }
  .xcmhotel_main{
    text-align: center;
    float: right;
    width: 400px;
    margin-right: 44px;
    margin-top: 50px;
  }
  .xcmhotel_logo{
    width: 305px;
  }
  .xcmhotel_dec{
    margin-top: 10px;
    text-indent: 2em;
    line-height: 2;
    text-align: left;
    font-size: 26px;
  }
  .more1{
    width: 183px;
    margin: 26px auto 0;
  }
  &::after{
    content: '';
    display: block;
    clear: both;
  }
}

.code_box {
  width: 64px;
  height: 282px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 32px;
  background: rgba($color: #f09325, $alpha: 0.7);
  position: fixed;
  right: 50px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 15px 0;
  box-sizing: border-box;
  transform: translateX(500px);
  .code_box_item {
    cursor: pointer;
    position: relative;
    img {
      max-width: unset;
    }
    .code1 {
      width: 28px;
    }
    .code2 {
      width: 160px;
      position: absolute;
      left: -200px;
      top: 20px;
      display: none;
      opacity: 0;
      box-shadow: 0px 6px 16px 0px rgba(69, 69, 69, 0.1);
    }
    .tel {
      width: 160px;
      left: -200px;
      height: 128px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-size: 20px;
        color: #000;
        margin-bottom: 10px;
      }
      span {
        font-size: 18px;
        color: #ff7417;
      }
    }
  }
}
.activities_list .main {
  .btn {
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 6px 16px 0px rgba(69, 69, 69, 0.1);
    width: 182px;
    height: 46px;
    font-family: SourceBold;
    margin-top: 24px;
    transition: 0.6s;
    font-size: 25px;
    color: rgb(237, 114, 31);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    z-index: 1;
    img {
      width: 18px;
      flex-shrink: 0;
      transition: all 0.3s;
    }
    &:hover {
      img {
        animation: exploring_btn 0.6s ease-in-out infinite;
      }
    }
  }
}
</style>